import { StrapiResponsiveImageData } from '../image';

export const componentName = 'shared.responsive-video';

export type StrapiVideoFile = { fields: { assetUrl: string } } | null;

export type ResponsiveVideoData = {
  videoDesktop: StrapiVideoFile;
  videoMobile: StrapiVideoFile;
  posterImage?: StrapiResponsiveImageData | null;
  autoPlay: boolean;
  strapi_component: typeof componentName;
};

type VideoAttributes = {
  name: string;
  alternativeText: string | null;
  caption: string | null;
  mime: string;
  url: string;
  fields: { assetUrl: string };
};

export type ResponsiveVideoPreview = {
  strapi_component: typeof componentName;
  VideoDesktop: VideoAttributes;
  VideoMobile: VideoAttributes;
  PosterImage?: StrapiResponsiveImageData | null;
  AutoPlay: boolean;
};
